import {match} from 'ts-pattern';

import {convertToAutoScout24} from './convertToAutoScout24';
import {convertToMarkdown} from './convertToMarkdown';
import {convertToMobileDe} from './convertToMobileDe';
import {convertToPlainText} from './convertToPlainText';
import {DescriptionFormat} from './types';

export function convertHtmlToFormat(html: string, format: DescriptionFormat): string {
  return match(format)
    .with('plainText', () => convertToPlainText(html))
    .with('html', () => html)
    .with('markdown', () => convertToMarkdown(html))
    .with('mobileDe', () => convertToMobileDe(html))
    .with('autoScout24', () => convertToAutoScout24(html))
    .exhaustive();
}
